import { Action } from "../../../action";
import { DefaultApi } from "../../../api";
import { getCatchError } from "../../../getCatchError";
import { urls } from "../../../urls";

const setGetViewTournamentStat = (params) => {
    return async (dispatch, getState) => {
        try {
            const { data } = await DefaultApi({
                params,
                method: 'get',
                url: urls.GET_VIEW_TOURNAMENT_STAT
            });

            if (data.status === 'success') {
                dispatch(Action.SetGetListTournamentStatAction(data.data))
            }

        } catch (error) {
            getCatchError(error)
        }
    }
}

export {
    setGetViewTournamentStat as SetGetViewTournamentStat
}